import { Image } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export function ProfileInfoPicureOptionSkeleton() {
  return (
    <div className={`${styles.container}`}>
      <Image width={50} height={50} alt="avatar-option-skeleton" />
      <div className={skeleton.name} />
    </div>
  );
}
